export default __webpack_public_path__ + "static/media/mi-healthcare-inc.9c3eeeb0.png";